import { Document } from "react-pdf";
import { useEffect } from 'react';

function CV() {
  useEffect(() => {
    document.title = 'CV';
  }, []);
  return (
    <embed src={process.env.PUBLIC_URL + '/Iskren_Dobrev_CV_Resume.pdf'} type="application/pdf" width="100%" height="100%" />
  );
}

export default CV;
